var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"datePicker",staticClass:"form-input form-datepicker form-control form-input-bordered",class:{ 'cursor-not-allowed': _vm.disabled },attrs:{"disabled":_vm.disabled,"type":"text","placeholder":_vm.placeholder}})
}
var staticRenderFns = []

export { render, staticRenderFns }